import { Line } from 'react-chartjs-2';
// import { useDarkMode } from "../../hooks";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import PropTypes from 'prop-types';
import { ChartContainer, ChartWrapper } from './line-chart.style';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Title);

const LineChart = ({
  data,
  xAxisLabel = 'Days of Month',
  chartTitle = 'Daily Transactions',
  lineColor = '#3989d8',
  pointRadius = 2,
}) => {
  // const [isDarkMode] = useDarkMode();

  // const axisColor = isDarkMode ? '#a9a9a9' : '#a9a9a9';
  const axisColor = '#a9a9a9';

  const chartData = {
    labels: data.map(item => item.date),
    datasets: [
      {
        label: '',
        data: data.map(item => item.volume),
        fill: false,
        borderColor: lineColor,
        backgroundColor: lineColor,
        tension: 0.4,
        pointRadius: pointRadius,
        pointBackgroundColor: lineColor,
        pointBorderColor: lineColor,
        pointHoverRadius: pointRadius + 2,
        pointHoverBackgroundColor: lineColor,
        pointHoverBorderColor: '#3989d8',
        borderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        // backgroundColor: 'var(--table-border-color)',
        // titleColor: 'var(--text-color-primary)',
        // bodyColor: 'var(--text-color-primary)',
        // borderColor: 'var(--table-border-color)',
        // borderWidth: 1,
        // padding: 10,
        // caretSize: 6,
        // cornerRadius: 6,
      },
    },
    layout: {
      padding: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xAxisLabel,
          color: axisColor,
          font: { size: 14 },
        },
        ticks: {
          color: axisColor,
          font: { size: 12 },
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: false,
        },
        ticks: {
          color: axisColor,
          font: { size: 12 },
          stepSize: 10,
        },
        grid: {
          display: false,
        },
        beginAtZero: false,
      },
    },
  };

  return (
    <ChartWrapper className='box-shadow'>
      <ChartContainer>
        {
          chartTitle &&
          <h4>{chartTitle}</h4>
        }
        <Line data={chartData} options={options} />
      </ChartContainer>
    </ChartWrapper>
  );
};

LineChart.propTypes = {
  data: PropTypes.array.isRequired,
  xAxisLabel: PropTypes.string,
  chartTitle: PropTypes.string,
  lineColor: PropTypes.string,
  pointRadius: PropTypes.number,
};

export default LineChart;
